export default [
  /**
   *  RUANG KELAS
   */

  {
    path: "/akademik/restore-krs",
    name: "akademik-restore-krs",
    component: () =>
      import("../../views/rektorat/akademik/restore-krs/RestoreKrs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },

        { title: "Restore KRS", active: true },
      ],
      pageTitle: "Restore KRS",
    },
  },
  /**
   *  RUANG KELAS
   */

  {
    path: "/akademik/ruang-kelas",
    name: "akademik-ruang-kelas",
    component: () =>
      import("../../views/rektorat/akademik/ruang-kelas/RuangKelas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },

        { title: "Ruang Kelas", active: true },
      ],
      pageTitle: "Ruang Kelas",
    },
  },

  /**
   *  REKAP PERKULIAHAN
   */

  {
    path: "/akademik/rekap-perkuliahan",
    name: "akademik-rekap-perkuliahan",
    component: () =>
      import(
        "../../views/rektorat/akademik/rekap-perkuliahan/RekapPerkuliahan.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },

        { title: "Rekap Perkuliahan", active: true },
      ],
      pageTitle: "Rekap Perkuliahan",
    },
  },

  /**
   *  REKAP KRS
   */
  {
    path: "/akademik/rekap-krs",
    name: "akademik-rekap-krs",
    component: () =>
      import("../../views/rektorat/akademik/rekap-krs/RekapKrs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },

        { title: "Rekap KRS", active: true },
      ],
      pageTitle: "Rekap KRS",
    },
  },
  /**
   *  MAHASISWA
   */
  {
    path: "/akademik/mahasiswa",
    name: "master-mahasiswa",
    component: () =>
      import("../../views/rektorat/akademik/mahasiswa/ListMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/akademik/nilai-mahasiswa/:userId",
    name: "akademik-nilai-mahasiswa",
    component: () =>
      import("../../views/rektorat/akademik/mahasiswa/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mahasiswa", url: "/akademik/mahasiswa" },
        {
          title: "Nilai Mahasiswa",
          active: true,
        },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },

  {
    path: "/akademik/detail-mahasiswa/:userId",
    name: "detail-mahasiswa",
    component: () =>
      import("../../views/rektorat/akademik/mahasiswa/DetailMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mahasiswa", url: "/akademik/mahasiswa" },
        { title: "Detail mahasiswa", active: true },
      ],
      pageTitle: "Detail mahasiswa",
    },
  },
  {
    path: "/akademik/krs-mahasiswa/:mahasiswaId",
    name: "akademik-krs-mahasiswa",
    component: () =>
      import("../../views/rektorat/akademik/mahasiswa/KrsMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mahasiswa", url: "/akademik/mahasiswa" },
        { title: "KRS mahasiswa", active: true },
      ],
      pageTitle: "KRS mahasiswa",
    },
  },

  /**
   *  MATAKULIAH
   */
  {
    path: "/akademik/matakuliah",
    name: "akademik-matakuliah",
    component: () =>
      import("../../views/rektorat/akademik/matakuliah/ProdiMatakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mata Kuliah", active: true },
      ],
      pageTitle: "Mata Kuliah",
    },
  },

  {
    path: "/akademik/matakuliah/prodi/:prodiId",
    name: "akademik-matakuliah-prodi",
    component: () =>
      import(
        "../../views/rektorat/akademik/matakuliah/PlotMatakuliahDosen.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mata Kuliah", url: "/akademik/matakuliah" },
        { title: "Prodi Matakuliah", active: true },
      ],
      pageTitle: "Prodi Mata Kuliah",
    },
  },
  {
    path: "/akademik/matakuliah/lihat-matakuliah/:prodiId",
    name: "akademik-matakuliah-lihat-prodi",
    component: () =>
      import("../../views/rektorat/akademik/matakuliah/LihatMatakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Mata Kuliah", url: "/akademik/matakuliah" },
        { title: "Lihat Plotting Mata Kuliah", active: true },
      ],
      pageTitle: "Lihat Plotting Mata Kuliah",
    },
  },
  /**
   *  FAKULTAS
   */
  {
    path: "/akademik/fakultas",
    name: "master-fakultas",
    component: () =>
      import("../../views/rektorat/akademik/fakultas/ListFakultas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Fakultas", active: true },
      ],
      pageTitle: "Fakultas",
    },
  },
  {
    path: "/akademik/tambah-fakultas",
    name: "tambah-fakultas",
    component: () =>
      import("../../views/rektorat/akademik/fakultas/TambahFakultas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Fakultas", url: "/akademik/fakultas" },

        { title: "Tambah Fakultas", active: true },
      ],
      pageTitle: "Tambah Fakultas",
    },
  },
  {
    path: "/akademik/edit-fakultas/:fakultasId",
    name: "edit-fakultas",
    component: () =>
      import("../../views/rektorat/akademik/fakultas/EditFakultas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Fakultas", url: "/akademik/fakultas" },

        { title: "Sunting Fakultas", active: true },
      ],
      pageTitle: "Sunting Fakultas",
    },
  },
  /**
   *  INFO AKADEMIK
   */
  {
    path: "/akademik/info-akademik",
    name: "info-akademik",
    component: () =>
      import("../../views/rektorat/akademik/info/InfoAkademik.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Info Akademik", active: true },
      ],
      pageTitle: "Info Akademik",
    },
  },

  /**
   *  KURIKULUM
   */
  {
    path: "/akademik/kurikulum",
    name: "akademik-kurikulum",
    component: () =>
      import("../../views/rektorat/akademik/kurikulum/Kurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  {
    path: "/akademik/kurikulum/:kurikulumId",
    name: "akademik-kurikulum-matkul",
    component: () =>
      import(
        "../../views/rektorat/akademik/kurikulum/DetailMataKuliahKurikulum.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Kurikulum", url: "/akademik/kurikulum" },
        { title: "Lihat Mata Kuliah", active: true },
      ],
      pageTitle: "Lihat Mata Kuliah",
    },
  },

  {
    path: "/akademik/kurikulum/translasi-matakuliah/:matkulId",
    name: "akademik-kurikulum-translasi-matakuliah",
    component: () =>
      import("../../views/rektorat/akademik/kurikulum/EditTranslasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Kurikulum", url: "/akademik/kurikulum" },
        { title: "Translasi Mata Kuliah", active: true },
      ],
      pageTitle: "Translasi Mata Kuliah",
    },
  },
  /**
   *  DOSEN
   */
  {
    path: "/akademik/dosen",
    name: "master-dosen",
    component: () =>
      import("../../views/rektorat/akademik/dosen/ListDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Dosen", url: "/akademik/dosen", active: true },
      ],
      pageTitle: "Dosen",
    },
  },

  {
    path: "/akademik/detail-dosen/:userId",
    name: "detail-dosen",
    component: () =>
      import("../../views/rektorat/akademik/dosen/DetailDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Dosen", url: "/akademik/dosen" },
        {
          title: "Detail Dosen",
          url: "/akademik/detail-dosen",
          active: true,
        },
      ],
      pageTitle: "Detail Dosen",
    },
  },

  {
    path: "/akademik/edit-dosen/:userId",
    name: "edit-dosen",
    component: () =>
      import("../../views/rektorat/akademik/dosen/EditDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Dosen", url: "/akademik/master-dosen" },

        {
          title: "Edit Dosen",
          url: "/akademik/edit-dosen",
          active: true,
        },
      ],
      pageTitle: "Edit Dosen",
    },
  },

  {
    path: "/akademik/reporting-dosen",
    name: "akademik-reporting-dosen",
    component: () =>
      import("../../views/rektorat/akademik/dosen/Reporting.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Reporting Dosen", url: "/akademik/reporting-dosen", active: true },
      ],
      pageTitle: "Reporting Dosen",
    },
  },

  {
    path: "/akademik/reporting",
    name: "akademik-reporting",
    component: () =>
      import("../../views/rektorat/akademik/dosen/Reporting.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Reporting Dosen", url: "/akademik/reporting", active: true },
      ],
      pageTitle: "Reporting Dosen",
    },
  },
  /**
   *  PRODI
   */
  {
    path: "/akademik/master-prodi",
    name: "master-prodi",
    component: () =>
      import("../../views/rektorat/akademik/prodi/ListProdi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        {
          title: "Program Studi",
          url: "/akademik/master-prodi",
          active: true,
        },
      ],
      pageTitle: "Program Studi",
    },
  },

  {
    path: "/akademik/edit-prodi/:prodiId",
    name: "edit-prodi",
    component: () =>
      import("../../views/rektorat/akademik/prodi/EditProdi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        {
          title: "Program Studi",
          url: "/akademik/master-prodi",
        },
        {
          title: "Sunting Program Studi",
          url: "/akademik/edit-prodi",
          active: true,
        },
      ],
      pageTitle: "Sunting Program Studi",
    },
  },
  /**
   *  SETTING INPUT NILAI
   */
  {
    path: "/akademik/setting-input-nilai",
    name: "akademik-setting-input-nilai",
    component: () =>
      import("../../views/rektorat/akademik/nilai/SettingInputNilai.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Setting Input Nilai", active: true },
      ],
      pageTitle: "Setting Input Nilai",
    },
  },

  {
    path: "/akademik/setting-input-nilai-individu",
    name: "akademik-setting-input-nilai-individu",
    component: () =>
      import(
        "../../views/rektorat/akademik/nilai/SettingInputNilaiIndividu.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        {
          title: "Setting Input Nilai",
          url: "/akademik/setting-input-nilai",
        },
        { title: "Setting Input Nilai Individu", active: true },
      ],
      pageTitle: "Setting Input Nilai Individu",
    },
  },
  /**
   *  PERIODE
   */
  {
    path: "/akademik/periode",
    name: "periode",
    component: () =>
      import("../../views/rektorat/akademik/periode/ListPeriode.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Periode", active: true },
      ],
      pageTitle: "Periode",
    },
  },

  {
    path: "/akademik/tambah-periode",
    name: "tambah-periode",
    component: () =>
      import("../../views/rektorat/akademik/periode/TambahPeriode.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Periode", url: "/akademik/periode" },

        { title: "Tambah Periode", active: true },
      ],
      pageTitle: "Tambah Periode",
    },
  },

  /**
   *  NILAI
   */
  {
    path: "/akademik/nilai",
    name: "akademik-nilai",
    component: () =>
      import("../../views/rektorat/akademik/nilai/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },

  // validasi ijazah
  {
    path: "/akademik/validasi-ijazah-mahasiswa",
    name: "validasi-ijazah-mahasiswa",
    component: () =>
      import(
        "../../views/rektorat/akademik/validasiIjazahMahasiswa/ValidasiIjazahMahasiswa.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Validasi Ijazah Mahasiswa", active: true },
      ],
      pageTitle: "Validasi Ijazah Mahasiswa",
    },
  },
  {
    path: "/akademik/aktivitas-mahasiswa",
    name: "akademik-aktivitas-mahasiswa",
    component: () =>
      import(
        "../../views/rektorat/akademik/aktivitas-mahasiswa/AktivitasMahasiswa.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Akademik", url: "/submenu/akademik" },
        { title: "Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Aktivitas Mahasiswa",
    },
  },
];
